import { IframeWindow } from '.';
import { card } from '../../api/card';

export class Card implements card.Api {
  constructor(private iframe: IframeWindow) {}

  selectCard(request?: card.SelectCardRequest): Promise<card.Card[]> {
    return this.iframe
      .twoWayCall<card.SelectCardRequest, card.Card[]>(
        request,
        (requestId, request) => {
          this.iframe.postMessage({
            command: 'card.selectCard',
            args: { ...request, requestId },
          });
        },
        (cardsResponse: card.Card[]): card.Card[] => {
          return cardsResponse.map((card) => {
            return {
              cardId: card.cardId,
              deleteCode: card.deleteCode,
              deleted: card.deleted,
              description: card.description,
              fullName: card.fullName,
              shortName: card.shortName,
              type: card.type,
            };
          });
        }
      )
      .catch(() => [] as card.Card[]);
  }

  createCard(): Promise<card.CreatedCard> {
    return this.iframe.twoWayCall<any, card.CreatedCard>(
      null,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'card.createCard',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          // Unable to parse response => response is not a stringify object
          responseData = response;
        }
        return responseData;
      }
    );
  }

  openCard(request: card.OpenCardRequest): void {
    this.iframe.postMessage({
      command: 'card.openCard',
      args: request,
    });
  }

  //   getLists(request: BaseRequest): Promise<card.Card[]> {
  //     return this.iframe.twoWayCall<BaseRequest, card.Card[]>(
  //       request,
  //       (requestId, request) => {
  //         this.iframe.postMessage({
  //           command: 'card.getLists',
  //           args: {
  //             ...request,
  //             requestId,
  //           },
  //         });
  //       },
  //       (response) => {
  //         let responseData;
  //         try {
  //           responseData = JSON.parse(response);
  //         } catch (e) {
  //           // Unable to parse response => response is not a stringify object
  //           responseData = response;
  //         }
  //         return responseData;
  //       }
  //     );
  //   }
}
